<script lang="ts">
  import type { ComponentProps, ComponentType } from 'svelte';
  import type { LazyComponent } from './Lazy.svelte';

  import { Route } from 'svelte-navigator';
  import Lazy from './Lazy.svelte';

  type Component = $$Generic<ComponentType>;
  export let component: LazyComponent<Component>;

  let props: ComponentProps<Route>;
  $: {
    // eslint-disable-next-line no-shadow
    const { component, delayMs, ...restProps } = $$props;
    props = restProps;
  }
</script>

<Route {...props}>
  <Lazy {component} />
</Route>
